export const routes = {
  jobs: "/jobs",
  job: "/jobs/detail",
  register: "/jobs/register",
  rewards: "/rewards",
};
